var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResidential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1748 6.62354H9.59944V8.03383H8.1748V6.62354Z",
    fill: "#00A851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1748 9.86035H9.59944V11.2706H8.1748V9.86035Z",
    fill: "#00A851"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7144 9.86035H16.139V11.2706H14.7144V9.86035Z",
    fill: "#00A851"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9844 9.86035H19.409V11.2706H17.9844V9.86035Z",
    fill: "#00A851"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7144 13.0972H16.139V14.5075H14.7144V13.0972Z",
    fill: "#00A851"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9844 13.0972H19.409V14.5075H17.9844V13.0972Z",
    fill: "#00A851"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7144 16.334H16.139V17.7443H14.7144V16.334Z",
    fill: "#00A851"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9844 16.334H19.409V17.7443H17.9844V16.334Z",
    fill: "#00A851"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7144 19.5713H16.139V20.9816H14.7144V19.5713Z",
    fill: "#00A851"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9844 19.5713H19.409V20.9816H17.9844V19.5713Z",
    fill: "#00A851"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90479 9.86035H6.32941V11.2706H4.90479V9.86035Z",
    fill: "#00A851"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1748 13.0972H9.59944V14.5075H8.1748V13.0972Z",
    fill: "#00A851"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90479 13.0972H6.32941V14.5075H4.90479V13.0972Z",
    fill: "#00A851"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1748 16.334H9.59944V17.7443H8.1748V16.334Z",
    fill: "#00A851"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90479 16.334H6.32941V17.7443H4.90479V16.334Z",
    fill: "#00A851"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6788 22.8081V6.62331H12.8692V3.25911L11.2342 3.52885V0.149414H3.26986V4.84291L1.63496 5.11265V22.8081H0V24.2184H24.3137V22.8081H22.6788ZM21.2541 8.0336V22.8081H12.8692V8.0336H21.2541ZM4.6945 1.55971H9.80959V3.7639L4.6945 4.60786V1.55971ZM3.05959 6.30736L11.4445 4.92391V6.62331V22.8081H9.59932V19.5711H4.90482V22.8081H3.05959V6.30736ZM8.17468 22.8081H6.32945V20.9814H8.17468V22.8081Z",
    fill: "#00A851"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidential);
export default __webpack_public_path__ + "static/media/residential.d8614539538d4935b0849ffc43051219.svg";
export { ForwardRef as ReactComponent };